/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.calendar.auto-setup'},
});

const AutoSetupItem = () => (
  <RouteLinkItem
    route="midas/settings/calendar/auto-setup"
    title={messages.title}
  />
);

export default AutoSetupItem;
